import React, { useEffect } from "react";

const CheckCircleIcon = ({ className = "h-5 w-5" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
  </svg>
);

export default function QrVerificationCard({
  templateState,
  setTemplateState,
  companyName = "",
  iquiqueCode = ""
}) {

  const handleChange = (e) => {
    const { name, type, checked } = e.target;

    // AUTO-FILL LOGIC RUNS SILENTLY IN THE BACKGROUND
    if (type === "checkbox" && name === "enableQR") {
      setTemplateState((prev) => ({
        ...prev,
        enableQR: checked,
        ...(checked && {
          // Uses the encoded iquiqueCode 
          iqCode: iquiqueCode || prev.iqCode,

          // Auto-fill Recipient Name if empty
          issuedTo: prev.issuedTo || prev.recipientName || "",

          // Auto-fill Company Name if empty
          issuedBy: prev.issuedBy || companyName || prev.companyName || ""
        })
      }));
    }
  };

  // Auto-sync 'Issued To' if the user types the Recipient Name AFTER checking the box
  useEffect(() => {
    if (templateState.enableQR && templateState.recipientName && !templateState.issuedTo) {
      setTemplateState((prev) => ({
        ...prev,
        issuedTo: prev.recipientName
      }));
    }
  }, [templateState.recipientName, templateState.enableQR, templateState.issuedTo, setTemplateState]);

  // Auto-sync 'iqCode' if the iquiqueCode is passed in AFTER the box is checked (e.g. loading an edit)
  useEffect(() => {
    if (templateState.enableQR && iquiqueCode && templateState.iqCode !== iquiqueCode) {
      setTemplateState((prev) => ({
        ...prev,
        iqCode: iquiqueCode
      }));
    }
  }, [iquiqueCode, templateState.enableQR, templateState.iqCode, setTemplateState]);

  return (
    <div className="card shadow-sm">
      <div className="card-body p-6">
        <h4
          className="card-title fw-bold mb-4"
          style={{ fontSize: "16px", color: "#000" }}
        >
          QR Verification
        </h4>

        {/* 1. ENABLE CHECKBOX */}
        <div
          className={`d-flex align-items-center gap-3 rounded border p-4 transition-all ${templateState.enableQR ? "border-primary bg-primary bg-opacity-10" : "border-secondary bg-light"
            }`}
        >
          <input
            type="checkbox"
            name="enableQR"
            id="enableQR"
            checked={templateState.enableQR}
            onChange={handleChange}
            className="form-check-input mt-0"
            style={{ width: "1.25rem", height: "1.25rem", cursor: "pointer" }}
          />
          <label htmlFor="enableQR" className="form-check-label fw-medium text-dark" style={{ cursor: "pointer" }}>
            Enable Verifiable QR Code in Footer
          </label>
        </div>

        {/* ONLY SHOW SUCCESS BANNER (Inputs Hidden) */}
        {templateState.enableQR && (
          <div className="mt-4 animate-in fade-in duration-300">
            <div className="d-flex align-items-center gap-3 rounded border border-success bg-success bg-opacity-10 p-4 text-success">
              <div className="flex-shrink-0">
                <CheckCircleIcon className="text-success" style={{ width: "1.25rem", height: "1.25rem" }} />
              </div>
              <span className="fw-medium">
                QR Code is fully configured and will be displayed in the footer.
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}